import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  title: { fontSize: 22, fontWeight: '600', mb: 1.5 },
  container: (isFr: boolean) =>
    ({
      px: 3,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: isFr ? '380px' : '290px',
      height: 180,
      pt: 2,
      border: '1px solid',
      borderColor: 'common.counterRed',
      backgroundColor: 'secondary.main',
      borderRadius: '10px',
      position: 'relative',
    }),
  label: {
    fontSize: 16,
    fontWeight: 500,
    color: 'grey.800',
  },
  closeIcon: { position: 'absolute', top: 10, right: 4 },
  value: { color: 'grey.900', wordBreak: 'break-word', fontSize: 14 },
  hurryContainer: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  hurryText: {
    fontSize: 16,
    fontWeight: '500',
    color: ThemeConstants.common.counterRed,
  },
  hurryMargin: {
    mr: '3px',
  },
} satisfies Record<string, SxProps<Theme> | ((isFr: boolean) => SxProps<Theme>)>;

export default styles;
